import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: { showNavigation: true },
  },
  {
    path: '/entrance',
    name: 'entrance',
    component: () => import('@/views/entrance/index.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/entrance/login.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/entrance/register.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@/views/entrance/forgot-password.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/flow',
    name: 'flow',
    component: () => import('@/views/flow'),
    meta: { showNavigation: true },
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('@/views/my'),
    meta: { showNavigation: true },
  },
  {
    path: '/personalInformation', // 个人信息
    name: 'personalInformation',
    component: () => import('@/views/my/components/personal-information'),
    meta: { showNavigation: false },
  },
  {
    path: '/goRealName', // 去实名认证
    name: 'goRealName',
    component: () => import('@/views/my/components/go-real-name'),
    meta: { showNavigation: false },
  },
  {
    path: '/addPhoneNumber', // 绑定手机号
    name: 'addPhoneNumber',
    component: () =>
      import('@/views/my/components/personal-information/add-phone-number'),
    meta: { showNavigation: false },
  },
  {
    path: '/billing', // 账单
    name: 'billing',
    component: () => import('@/views/my/components/billing'),
    meta: { showNavigation: false },
  },
  {
    path: '/paymentReceiptInformation', // 收付款信息
    name: 'paymentReceiptInformation',
    component: () =>
      import('@/views/my/components/payment-receipt-information'),
    meta: { showNavigation: false },
  },
  {
    path: '/addPayeeAccount', // 添加收款账号
    name: 'addPayeeAccount',
    component: () =>
      import(
        '@/views/my/components/payment-receipt-information/add-payee-account'
      ),
    meta: { showNavigation: false },
  },
  {
    path: '/transactionLockAmount', // 交易锁定金额
    name: 'transactionLockAmount',
    component: () => import('@/views/my/components/transaction-lock-amount'),
    meta: { showNavigation: false },
  },
  {
    path: '/securitySetting', // 安全设置
    name: 'securitySetting',
    component: () => import('@/views/my/components/security-setting'),
    meta: { showNavigation: false },
  },
  {
    path: '/changePassword', // 密码修改
    name: 'changePassword',
    component: () =>
      import('@/views/my/components/security-setting/change-password'),
    meta: { showNavigation: false },
  },
  {
    path: '/aboutUs', // 关于我们
    name: 'aboutUs',
    component: () => import('@/views/my/components/about-us'),
    meta: { showNavigation: false },
  },
  {
    path: '/tradingMarket',
    name: 'buytradingMarketPage',
    component: () => import('@/views/tradingMarket/index'),
    meta: { showNavigation: false },
  },
  {
    path: '/pendingOrder',
    name: 'pendingOrder',
    component: () => import('@/views/tradingMarket/pending-order'),
    meta: { showNavigation: false },
  },
  {
    path: '/buyOrder',
    name: 'buyOrder',
    component: () => import('@/views/tradingMarket/buy-order.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/usdtTradingMarket',
    name: 'usdtBuytradingMarketPage',
    component: () => import('@/views/usdtMarket/index'),
    meta: { showNavigation: false },
  },
  {
    path: '/usdtPendingOrder',
    name: 'usdtPendingOrder',
    component: () => import('@/views/usdtMarket/pending-order'),
    meta: { showNavigation: false },
  },
  {
    path: '/usdtBuyOrder',
    name: 'usdtBuyOrder',
    component: () => import('@/views/usdtMarket/buy-order.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/order/index.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/notifications/index.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('@/views/currency/recharge.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () => import('@/views/currency/withdrawal.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/withdrawalOrder',
    name: 'withdrawalOrder',
    component: () => import('@/views/order/withdrawal.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/coinTrading',
    name: 'coinTrading',
    component: () => import('@/views/order/coin-trading.vue'),
    meta: { showNavigation: false },
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('@/views/game/index.vue'),
    meta: { showNavigation: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const notBgPage = ['home', 'flow', 'my', 'entrance','game'];
  if (!notBgPage.includes(to.name)) {
    document.body.style.backgroundColor = '#4263EB';
  } else {
    document.body.style.backgroundColor = 'white';
  }
  next(); // 继续导航
});
export default router;
